<div class="empty-set-panel">
  <img src="assets/images/{{icon}}.svg" *ngIf="icon">
  <h4 *ngIf="title">{{title}}</h4>
  <p *ngIf="caption">{{caption}}</p>
</div>
